<template>
  <div class="aboutWrapper">
    <dwgwcontenheader :imgsrc="img"></dwgwcontenheader>
    <dwgwcontenstabs :contentsList="contentsList">
      <a class="joinUS" target="_blank" href="https://www.zhipin.com/gongsi/527041e06dc55ec41nF72tS5Ew~~.html?ka=job-detail-company-logo_custompage">点击查看招聘详情</a>
    </dwgwcontenstabs>
  </div>
</template>
 
<script>
import dwgwcontenheader from "@/components/dwgwcontenheader";
import dwgwcontenstabs from "@/components/dwgwcontenstabs";
export default {
  name: "dwgwabout",
  components: {
    dwgwcontenheader,
    dwgwcontenstabs,
  },
  data() {
    return {
      img: require("./jpg/index1_3.png"),
      contentsList: [
        {
          title: "加入蝶威",
          contentData: [
            "对冲基金是一个朝气蓬勃、前景广阔的行业， 而深度的数据分析、 严格的交易执行和强大稳定的IT系统将是行业长期盈利和风险控制的基石。 蝶威量化作为国内业界最早和最重要的参与者之一，愿汇聚各行业最拔尖的人才， 共同致力于解决世界级的难题，进行他人难以想象的创新研究，共同成就非凡的事业。",
            "如果你智力超群甚至是个Geek，如果你拥有强烈好奇心与创造力， 如果你正直善良并且拥有良好的心理素质，欢迎加入蝶威量化， 共同参与到这场世界上最富魅力的智力游戏中，蝶威量化将为你提供更高的起点， 更健全的行业指导以及更广阔的职业舞台。",
            "提示：简历投递请使用PC端浏览器。",
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.aboutWrapper {
  width: 1140px;
  margin: 0 auto;
  margin-top: 100px;
}
.joinUS {
  display: inline-block;
  text-align: center;
  text-decoration: none;
  color: #666;
  border: 1px solid #c8ad6d;
  border-radius: 3px;
  margin-top: 50px;
  font-size: 14px;
  padding: 15px 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwjoin.vue